import React from 'react';
import { Menu } from 'dig-components/menu';

import { GenericObject } from 'common/types/generic-object';
import { EntityAccessSelectedListItem } from './entity-access-selected-list-item';

function getScopedEntities(entities: GenericObject[]) {
  return entities
    .filter((entity) => (
      entity.isAdmin
        || entity.isOwner
        || entity.hasExplicitTemplateAccess
        || entity.isAccessDirty
    ))
    .sort((a, b) => {
      if (a.isAccessDirty) {
        if (b.isAccessDirty) {
          if (a.isAccessDirtyFromSearch) {
            if (b.isAccessDirtyFromSearch) {
              if (a.dateLastSearched > b.dateLastSearched) {
                return -1;
              } else if (a.dateLastSearched < b.dateLastSearched) {
                return 1;
              } else {
                return 0;
              }
            } else {
              return -1;
            }
          } else {
            return b.isAccessDirtyFromSearch ? 1 : 0;
          }
        } else {
          return a.isAccessDirtyFromSearch ? -1 : 0;
        }
      } else {
        return b.isAccessDirtyFromSearch ? 1 : 0;
      }
    });
}

interface Props {
  entities: GenericObject[];
  recentEntity?: string;
  isEditable: boolean;
  grantAccess: Function;
  revokeAccess: Function;
  resetAccess: Function;
}

/**
 * Renders the team access modal access list.
 *
 * @param {Object} props
 */

export function EntityAccessSelectedList(props: Props) {
  const {
    entities,
    isEditable,
    grantAccess,
    revokeAccess,
    resetAccess,
  } = props;
  const entitiesInScope = React.useMemo(() => getScopedEntities(entities), [entities]);

  return (
    <Menu.Segment
      className='team-access-modal__entity-access-selected-list-container'
    >
      {entitiesInScope.map((entity) => {
        return (
          <EntityAccessSelectedListItem
            key={entity.guid}
            entity={entity}
            isEditable={isEditable}
            grantAccess={grantAccess}
            revokeAccess={revokeAccess}
            resetAccess={resetAccess} />
        );
      })}
    </Menu.Segment>
  );
}
